const businessAccents = ['#1c7ed6', '#f08c00', '#ae3ec9', '#0b7285', '#e8590c']

export function workspaceAccent(id: string, type?: string) {
  if (String(type || '').toUpperCase() === 'PERSONAL') return '#2f9e44'
  let hash = 0
  for (let index = 0; index < id.length; index += 1) {
    hash = (hash * 31 + id.charCodeAt(index)) >>> 0
  }
  return businessAccents[hash % businessAccents.length]
}
